import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef, lazy, Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "./Breadcrumbs";
import ClientLogos from "./ClientLogos";
import { trackPageView } from "@/lib/analyticsTracker";

// Lazy load non-critical UI that isn't visible above the fold
const FloatingWhatsApp = lazy(() => import("./FloatingWhatsApp"));
const MobileStickyContact = lazy(() => import("./MobileStickyContact"));
const CityDetectionPopup = lazy(() => import("./CityDetectionPopup"));

const Layout = () => {
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/rio-de-janeiro" || location.pathname === "/goianesia";
  const prevPath = useRef(location.pathname);

  // Track SPA route changes
  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      prevPath.current = location.pathname;
      trackPageView();
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col pb-14 md:pb-0">
      <Header />
      {!isHome && <Breadcrumbs />}
      <main className="flex-1">
        <Outlet />
      </main>
      <ClientLogos />
      <Footer />
      <Suspense fallback={null}>
        <FloatingWhatsApp />
        <MobileStickyContact />
        <CityDetectionPopup />
      </Suspense>
    </div>
  );
};

export default Layout;
